export default __webpack_public_path__ + "static/media/blue-autumn.5305c0fb.png";